// import React, { useState } from "react";
// import { uploadFile } from "react-s3";

// const UploadImageToS3WithReactS3 = () => {
// 	const [selectedFile, setSelectedFile] = useState(null);

// 	const handleFileInput = (e) => {
// 		setSelectedFile(e.target.files[0]);
// 	};

// 	const handleUpload = async (file) => {
// 		uploadFile(file, config)
// 			.then((data) => console.log(data))
// 			.catch((err) => console.error(err));
// 	};

// 	return (
// 		<div>
// 			<input type="file" onChange={handleFileInput} />
// 			<button onClick={() => handleUpload(selectedFile)}> Upload to S3</button>
// 		</div>
// 	);
// };

// export default UploadImageToS3WithReactS3;

// const ACCESS_KEY = "AKIAQ5UEKWYU4RU5BJV4";
// const SECRET_ACCESS_KEY = "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";

// const config = {
// 	bucketName: S3_BUCKET,
// 	region: REGION,
// 	accessKeyId: ACCESS_KEY,
// 	secretAccessKey: SECRET_ACCESS_KEY,
// };
import React, { useState } from "react";
import AWS from "aws-sdk";
import { useDispatch } from "react-redux";
import { uploadDataRequest } from "../../redux/reducers/ducks/seededDuck";
import { getToasterNotifications } from "../../utils/getToasterNotification";
import "./uploadVideoS3.css";
import DisplayVideos from "../displayVideos/displayVideos";

const S3_BUCKET = "pic-and-vid-central";
const REGION = "us-east-1";

AWS.config.update({
	accessKeyId: "AKIAQ5UEKWYU4RU5BJV4",
	secretAccessKey: "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",
});

const myBucket = new AWS.S3({
	params: { Bucket: S3_BUCKET },
	region: REGION,
});

const UploadImageToS3WithNativeSdk = ({ balloonId }) => {
	// console.log(balloonId+'asjdkasdj')
	const [progress, setProgress] = useState(0);
	const [selectedFile, setSelectedFile] = useState(null);

	const dispatch = useDispatch();
	const handleFileInput = (e) => {
		setSelectedFile(e.target.files[0]);
	};

	const uploadFile = (file) => {
		console.log();
		const params = {
			ACL: "public-read",
			Body: file,
			Bucket: S3_BUCKET,
			Key: `${Date.now().toString()}-${file.name}`,
		};

		myBucket
			.putObject(params)
			.on("httpUploadProgress", (evt) => {
				setProgress(Math.round((evt.loaded / evt.total) * 100));
			})
			.send((err) => {
				if (err) {
					console.log(err);
				} else {
					const url = `https://pic-and-vid-central.s3.amazonaws.com/${Date.now().toString()}-${
						file.name
					}`;
					dispatch(
						uploadDataRequest({
							videoUrl: url,
							balloonId: balloonId,
							status: "pending",
						})
					);
					getToasterNotifications("vedio uploaded successfully");
					console.log("url4444", url);
				}
			});
	};

	return (
		<div className="container d-flex around mt-4">
			<DisplayVideos />
			<div className="fit-content border shadow-sm p-2 rounded-4 mb-2">
				<div className="mt-2 d-flex">
					<span className="">
						<input type="file" accept=".mp4" onChange={handleFileInput} />
						<br />
						<div className="mt-3 mb-0">File Upload Progress is {progress}%</div>
						<br />
						{/* <div className="mb-0">
							<CheckBox></CheckBox>
						</div> */}
						<br />
						<button
							className="change-passwords"
							onClick={() => uploadFile(selectedFile)}
							style={{ margin: "4% 0 0 40%", padding: "6px 10px" }}
						>
							Save
						</button>
					</span>
				</div>
			</div>
		</div>
	);
};

export default UploadImageToS3WithNativeSdk;
